<template>
	<div class="omapi-datepicker-input">
		<label v-if="label">{{ label }}</label>
		<el-date-picker
			type="daterange"
			unlink-panels
			start-placeholder="Start date"
			end-placeholder="End date"
			format="MMM d, yyyy"
			ref="datepicker"
			:picker-options="pickerOptions"
			:clearable="false"
			:align="align"
			v-model="dateSelection"
		/>
	</div>
</template>

<script>
import { dates } from '@/utils'
import '@/components/core/form/datepicker-variables.scss'

export default {
	name  : 'DatepickerInput',
	props : {
		label : {
			type    : String,
			default : '',
		},
		align : {
			type    : String,
			default : 'left',
		},
		openImmediate : {
			type    : Boolean,
			default : false,
		},
		dateRange : {
			type     : Array,
			required : true,
		},
		minDate : {
			type    : Date,
			default : () => new Date(2013, 0), // When OM was started?!
		},
	},
	data () {
		return {
			pickerOptions : {
				shortcuts : [
					{
						text : 'Today',
						onClick (picker) {
							const today = new Date()
							today.setHours(0, 0, 0, 0)
							picker.$emit('pick', [ today, today ])
						},
					},
					{
						text : 'Yesterday',
						onClick (picker) {
							const yesterday = dates.yesterday()
							picker.$emit('pick', [ yesterday, yesterday ])
						},
					},
					{
						text : 'Last Week',
						onClick (picker) {
							const lw = dates.lastWeek()
							picker.$emit('pick', [ lw.start, lw.end ])
						},
					},
					{
						text : 'This Month',
						onClick (picker) {
							const tm = dates.thisMonth()
							picker.$emit('pick', [ tm.start, tm.end ])
						},
					},
					{
						text : 'Last Month',
						onClick (picker) {
							const lm = dates.lastMonth()
							picker.$emit('pick', [ lm.start, lm.end ])
						},
					}, {
						text : 'Last 3 Months',
						onClick (picker) {
							const l3m = dates.lastMonths(3)
							picker.$emit('pick', [ l3m.start, l3m.end ])
						},
					},
				],
				disabledDate : this.disabledDate,
			},
		}
	},
	computed : {
		dateSelection : {
			get () {
				return  this.dateRange
			},
			set (newValue) {
				this.$emit('input', newValue)
			},
		},
	},
	methods : {
		disabledDate (date) {
			const time = date.getTime()

			return time > Date.now() || time < this.minDate.getTime()
		},
	},
	mounted () {
		if  (this.openImmediate) {
			this.$refs.datepicker.focus()
		}
	},
}
</script>

<style lang="scss">
	.omapi-datepicker-input {
		text-align: left;
		label {
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 10px;
		}
	}
</style>
